import React, {FC, useEffect, useState} from "react";
import {Link, useParams} from "react-router-dom";
import useCommon from "../../../common/hooks/useCommon";
import {addressService, tokenService} from "../../../store/actions";
import BEmpty from "../../../components/b-empty";
import BPaginate from "../../../components/b-paginate";
import {centerTruncate, serializeQuery} from "../../../common/utils/function";
import BCopy from "../../../components/b-copy";
import NFTImage from "../../nft-details/common/nft-image";
import BSkeletonGrid from "../../../components/b-skeleton/b-skeleton-grid";
import {useTranslation} from "react-i18next";

interface XRC721InventoryListProps {
}

interface TransactionListData {
    token: any;
    image_url: any;
    id: any;
    owner: any;
    block: number;
    timestamp: string | number;
    extraMark: string;
    from: string;
    to: string;
    tokenId: string | number;
    value: string | number;
    gas_price: string | number;
}

const XRC721InventoryList: FC<XRC721InventoryListProps> = (props) => {
    const {address, token} = useParams();
    const {getTime, getXDC, get0x} = useCommon();
    const {t, i18n} = useTranslation();

    const [transactionList, setTransactionList] = useState<TransactionListData[]>([]);
    const [loading, setLoading] = useState(true);
    const [pageParams, setPageParams] = useState<any>([null]);
    const [pageIndex, setPageIndex] = useState<any>(0);
    const getBlocks = async () => {
        try {
            setLoading(true);
            if (address) {
                addressService.getAddressTokens(address || token, serializeQuery({type: "ERC-721", ...pageParams[pageIndex]})).then((response) => {
                    setTransactionList(response?.items);
                    setPageParams((prevState: any) => {
                        prevState[pageIndex + 1] = response?.next_page_params;
                        return prevState;
                    });
                    setLoading(false);
                })
                    .catch((e) => setLoading(false));
            } else if (token) {
                tokenService.getTokenInventory(token, serializeQuery(pageParams[pageIndex])).then((response) => {
                    setTransactionList(response?.items);
                    setPageParams((prevState: any) => {
                        prevState[pageIndex + 1] = response?.next_page_params;
                        return prevState;
                    });
                    setLoading(false);
                }).catch((e) => setLoading(false));
            }
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        getBlocks();
    }, [pageIndex, address]);
    return (
        <div className="bs-card">
            <div className="bs-card-header py-3 px-4 d-flex align-items-center justify-content-between">
                <h2 className="bs-card-header-title">{t("Tokens")}</h2>
                <div>
                    <BPaginate pageIndex={pageIndex} onChange={(data) => setPageIndex(data)}/>
                </div>
            </div>
            <div className="bs-card-body">
                <div className="row">
                    {loading ? <BSkeletonGrid length={50}/> : (
                        <React.Fragment>
                            {transactionList?.map((transaction) => {
                                return (
                                    <div className="col-xl-2 col-lg-3 col-md-4 col-sm-12 col-xs-12 mb-3" key={transaction?.token?.address}>
                                        <div className="bs-nft-block-wrapper">
                                            <a href={`/nft/${get0x(transaction?.token?.address)}/${transaction?.tokenId || transaction?.value}`}
                                               className="text-truncate">
                                                <div className="bs-nft-block bs-nft-block-edn">
                                                    <div className="bs-nft-img">
                                                        <div>
                                                            <NFTImage image={transaction?.image_url}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                            <div className="font-size-1 text-secondary text-truncate mb-1">
                                                {t("ID")}:
                                                <Link to={`/nft/${get0x(transaction?.token?.address)}/${transaction?.tokenId || transaction?.value}`}>
                                                    {" "}
                                                    {transaction?.tokenId || transaction?.id || transaction?.value}{" "}
                                                </Link>
                                            </div>
                                            {address && (
                                                <div className="font-size-1 text-secondary text-truncate mb-1">
                                                    {t("Address")}:{" "}
                                                    <a href={`/tokens/${get0x(transaction?.token?.address)}?address=${get0x(address)}`} className="text-truncate">
                                                        {getXDC(transaction?.token?.address)}
                                                    </a>
                                                </div>
                                            )}
                                            {token && transaction?.owner?.hash?.length && (
                                                <div className="font-size-1 text-secondary mb-1">
                                                    {t("Owner")}:{" "}
                                                    <a href={`/address/${get0x(transaction?.owner?.hash)}`}>{centerTruncate(getXDC(transaction?.owner?.hash))}</a>
                                                    <BCopy value={getXDC(transaction?.owner?.hash)}/>
                                                </div>
                                            )}
                                            {address && (<div className="font-size-1 text-secondary text-truncate">{t("Last Traded")}: N/A</div>)}
                                        </div>
                                    </div>
                                );
                            })}
                        </React.Fragment>
                    )}
                </div>
                {!loading && transactionList?.length === 0 && <BEmpty text=""/>}
            </div>
            <div className="bs-card-footer p-3">
                <BPaginate pageIndex={pageIndex} onChange={(data) => setPageIndex(data)}/>
            </div>
        </div>
    );
};

export default XRC721InventoryList;
